import angular from 'angular';
import Vue from 'vue';
import DomoEmbedList from './DomoEmbedList.vue';
import DomoEmbedForm from './DomoEmbedForm.vue';
import domoEmbedsApi from './api';

// Export Vue components for direct import
export {
  DomoEmbedList,
  DomoEmbedForm,
};

// Register Vue components with Angular
const domoEmbedsModule = angular.module('adminPanel.domoEmbeds', ['ngVue'])
  .factory('domoEmbedsApi', domoEmbedsApi)
  .directive('domoEmbedList', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('domo-embed-list', DomoEmbedList));
  }])
  .directive('domoEmbedForm', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('domo-embed-form', DomoEmbedForm));
  }]);

export default domoEmbedsModule;
